import { Component, OnInit } from '@angular/core';
import { TopbarService } from 'src/app/core/topbar/topbar.service';

@Component({
    selector: 'app-help-center',
    templateUrl: './help-center.component.html',
    styleUrls: ['./help-center.component.scss'],
    standalone: false
})
export class HelpCenterComponent implements OnInit {


    constructor(
        private topbarService: TopbarService) {     
      }
      
    ngOnInit(): void {
        this.topbarService.setTitle("Centro de ayuda");
       
      }
    openUserManual() {
        window.open('/assets/help/Manual_Configuracion_ERP_GUAI_V001.html', '_blank');
    }

    openUrl(url: string){
        window.open(url, '_blank');
    }
}
